<app-document-subheader></app-document-subheader>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (this.documentType$ | async; as documentType) {
        <div
          class="page-container"
          >
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label class="form-title-label" translate
                        >DOCUMENT_TYPE_LBL_NAME</label
                        >
                        <div class="form-title">{{ documentType.name }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 col-lg-6">
                      <div class="form-group row">
                        <label class="col-4 col-form-label-sm" translate
                          >DOCUMENT_TYPE_LBL_DESCRIPTION</label
                          >
                          <div class="col">
                            <span class="form-control-plaintext form-control-sm">
                              {{ documentType.description }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        @if (this.documentType$ | async; as documentType) {
          <div
            class="col-comment"
            >
            <app-comment-panel
              [entityType]="'DocumentType'"
              [entityId]="documentType.id.toString()"
            ></app-comment-panel>
          </div>
        }
      </div>
    </div>
